export default "__VITE_ASSET__BcqI4ZeM__"